import React, { useState, useEffect } from "react";
import "../styles/Skills.css";

const SkillCategory = ({ title, skills, icon, isLocked, isHovered, onToggle, onHover, onLeave, isTouchDevice }) => {
  // On touch devices, only use locked state; on desktop, use both hover and locked
  const isExpanded = isTouchDevice ? isLocked : (isLocked || isHovered);

  return (
    <div
      className={`skills__category ${isExpanded ? "expanded" : ""} ${isLocked ? "locked" : ""}`}
      onMouseEnter={!isTouchDevice ? onHover : undefined}
      onMouseLeave={!isTouchDevice ? onLeave : undefined}
    >
      <button className="skills__category-header" onClick={onToggle} aria-expanded={isExpanded}>
        <div className="skills__category-icon">
          <i className={icon}></i>
        </div>
        <span className="skills__category-title">{title}</span>
        <i className={`fas fa-chevron-down skills__category-arrow`}></i>
      </button>

      <div className="skills__category-content">
        <div className="skills__tags">
          {skills.map((skill, index) => (
            <span
              key={index}
              className="skills__tag"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const Skills = ({ skills, section = {} }) => {
  const [lockedCategories, setLockedCategories] = useState({});
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Detect touch device
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  const toggleCategory = (category) => {
    setLockedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const handleHover = (category) => {
    setHoveredCategory(category);
  };

  const handleLeave = () => {
    setHoveredCategory(null);
  };

  return (
    <section
      className="skills section wow animate__animated animate__fadeInUp"
      id="skills"
    >
      <span className="section__subtitle">{section.subtitle}</span>
      <h2 className="section__title">{section.title}</h2>

      <div className="skills__container">
        <div className="skills__grid">
          {skills.map((category) => (
            <SkillCategory
              key={category.key}
              title={category.title}
              skills={category.items}
              icon={category.icon}
              isLocked={lockedCategories[category.key]}
              isHovered={hoveredCategory === category.key}
              onToggle={() => toggleCategory(category.key)}
              onHover={() => handleHover(category.key)}
              onLeave={handleLeave}
              isTouchDevice={isTouchDevice}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
